enum UPLOAD_SERVICE {
  UNDEFINED,
  CR_CHALLENGE = 10
}

export default UPLOAD_SERVICE
